import { Box } from '@apia/theme';
import { keyframes } from '@emotion/react';
const shimmer = keyframes`
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.8;
  }
`;

const SkeletonItem = () => (
  <Box
    sx={{
      height: 20,
      bg: 'muted',
      mb: 2,
      borderRadius: 4,
      animation: `${shimmer} 1.5s infinite`,
      background: 'palette.gray.800',
    }}
  />
);

export const ListSkeletonLoader = ({ items = 5 }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    {Array.from({ length: items }).map((_, index) => (
      <SkeletonItem key={index} />
    ))}
  </Box>
);
